var Pages = {};

Pages.default = require('./_basePage');
Pages.Home = require('./Home');
Pages.wc_SingleProduct = require('./wc_SingleProduct');
Pages.AboutUs = require('./AboutUs');

module.exports = Pages;